import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"
import { Client } from "@/gql"
import ExpansionPanels from "@/components/widgets/accordion/ExpansionPanels.vue"
import ExpansionPanel from "@/components/widgets/accordion/ExpansionPanel.vue"
import ExpansionHeader from "@/components/widgets/accordion/ExpansionHeader.vue"
import ExpansionContent from "@/components/widgets/accordion/ExpansionContent.vue"
import useRouter from "@/router/useRouter"
import { useAccountContext } from "@/hooks/useAccountContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientInfo',
  props: {
    client: null
  },
  setup(__props: any) {

const props = __props as {
  client: Pick<Client, "name" | "email" | "companyLogoUrl" | "verified" | "id">
}

const { router, routes } = useRouter()
const { isConsultant } = useAccountContext()



const goToClientDetail = () => {
  if (isConsultant) return

  router.push({
    name: routes.ClientDetail,
    params: { id: props.client.id.toString() },
  })
}

return { __sfc: true,router, routes, isConsultant, props, goToClientDetail, Icon, ExpansionPanels, ExpansionPanel, ExpansionHeader, ExpansionContent }
}

})